import { render, staticRenderFns } from "./ChatPopupNotifications.vue?vue&type=template&id=050ff7fc&scoped=true"
import script from "./ChatPopupNotifications.vue?vue&type=script&lang=ts"
export * from "./ChatPopupNotifications.vue?vue&type=script&lang=ts"
import style0 from "./ChatPopupNotifications.vue?vue&type=style&index=0&id=050ff7fc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050ff7fc",
  null
  
)

export default component.exports